<template>
  <div>
    <Header showBack></Header>
    <div class="parking" :style="{ minHeight: height + 'px' }">
      <div class="fixed">
        <div class="header">
          <div class="left">
            <DatePicker :value.sync="date" :month="true" :noMin="true"> </DatePicker>
          </div>
        </div>

        <div class="top" ref="topScroll">
          <div class="con">
            <div class="date" v-for="(item, index) in list" v-bind:key="index" @click="select = index + 1">
              <div :class="`area ${select === index + 1 && 'active'}`">
                <span class="week"> {{ $t('common.day' + dateFormat(+item)[0]).slice(2) }}</span>
                <span class="day">
                  {{
                    dateFormat(+item)[1]
                      .toString()
                      .padStart(2, '0')
                  }}</span
                >
              </div>
              <!-- <div class="foot">
              <span class="invite" v-if="hasMeeting(item.list)[0]"></span>
              <span class="book" v-if="hasMeeting(item.list)[1]"></span>
            </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="titleSection">
        <p class="carTitle">{{ $t('appointment.visitors.cars.parking') }}</p>
        <div class="right">
          <span :class="['booking', 'itemBook']">{{ $t('appointment.visitors.booking') }}</span>
          <span :class="['booked', 'itemBook']">{{ $t('appointment.visitors.booked') }}</span>
          <span :class="['unbook', 'itemBook']">{{ $t('appointment.visitors.unbook') }}</span>
          <!-- <TypeSelect :value.sync="type"></TypeSelect> -->
        </div>
      </div>
      <Skeleton title :row="8" :loading="loading">
        <div class="list" v-for="(item, index) in listFilterCar" v-bind:key="index">
          <div class="listTop">
            <span class="title">{{ $t('appointment.visitors.parking.space' + index) }}</span>

            <img slot="icon" :src="arrowRight" @click="goToRoom(item, index)" class="arrowRight" />
            <!-- <span class="option">
            <a @click="goToRoom(item)">{{ $t('meeting.list.detail') }}</a>
            <Button type="primary" size="small" icon="plus" @click="goToAdd(item)">
              <span class="btn"> {{ $t('meeting.list.book') }}</span>
            </Button>
          </span> -->
          </div>

          <div class="content">
            <div class="section">
              <div
                class="area"
                v-for="(time, index) in item"
                v-bind:key="'11' + index"
                :style="{
                  left: (index * 100) / 48 + '%',
                  backgroundColor: +time === 1 ? 'transparent' : +time === 2 ? '#06CCBF' : '#FE8F7F',
                }"
              ></div>
              <div
                class="dot"
                v-for="(item, index) in times1"
                v-bind:key="'12' + index"
                :style="{ left: (index * 100) / 12 + '%' }"
              >
                {{ item }}
              </div>
            </div>

            <!-- <div class="section">
            <div
              class="area"
              v-for="(time, index) in item.timeList.slice(24, 48)"
              v-bind:key="'21' + index"
              :style="{
                left: (index * 100) / 24 + '%',
                backgroundColor: time === 1 ? 'transparent' : time === 2 ? '#06CCBF' : '#FE8F7F',
              }"
            ></div>
            <div
              class="dot"
              v-for="(item, index) in times2"
              v-bind:key="'22' + index"
              :style="{ left: (index * 100) / 12 + '%' }"
            >
              {{ item | hourFormat }}
            </div>
          </div> -->
          </div>
        </div>
      </Skeleton>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { Skeleton } from 'vant';
import DatePicker from '@/components/meetingDateSelect';
// import Iconfont from '@/components/icon.vue';
// import TypeSelect from '@/components/meetingTypeSelect';
import api from '@/services/api';
import Header from '@/components/header.vue';

import arrowRight from '@/assets/icon/arrowRight.svg';

export default {
  components: { DatePicker, Skeleton, Header },
  data() {
    return {
      date: new Date(),
      type: 0,
      loading: false,
      select: moment().date(),
      showSearch: false,
      times1: [0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24],
      // times1: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
      //   times1: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      //   times2: [12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
      arrowRight,
    };
  },
  computed: {
    authorId() {
      return this.$route.query.authorId;
    },
    applyInfo() {
      return this.$store.state.visitor.visitorApplyInfo;
    },
    height() {
      return window.innerHeight - parseInt(document.body.style.fontSize) * 1.17333;
    },
    list() {
      return this.$store.state.visitor.visitorInMonth;
    },
    meetingList() {
      return this.$store.state.visitor.visitorCarList || [];
    },
    listFilterCar() {
      return this.meetingList.filter(item => {
        let regxp = new RegExp(this.title);
        return regxp.test(item);
      });
    },
    listFilter() {
      let res = [];
      this.list.filter((item, index) => {
        let judge = index + 1 === this.select;
        if (judge) res = item.list;
        return judge;
      });
      if (this.type === 1) {
        res = res.filter(item => item.creatorId !== this.userId);
      } else if (this.type === 2) {
        res = res.filter(item => item.creatorId === this.userId);
      }
      return res;
    },
    // url() {
    //   return this.$route.path;
    // },
    // historyInfo() {
    //   return window.history.state && window.history.state.info;
    // },
  },
  filters: {
    hourFilter(value) {
      return moment(value).format('HH:mm');
    },
    hourFormat(value) {
      if (value && value % 2 === 0) {
        return value + ':00';
      } else {
        return '';
      }
    },
  },
  methods: {
    async initCarList() {
      // const res = await api.getPublicResource('./json/meeting.json');
      const [status, res] = await api.getVisitorCarInfoList({
        authorId: this.authorId,
        date: moment(this.date).startOf('days').valueOf(),
      });
      if (!status) return;
      this.$store.commit('visitor/updateVisitorCarList', res.data);
      this.loading = false;
    },
    async initData() {
      // this.loading = !this.list.length;
      // const res = await api.getPublicResource('./json/month.json');
      const [status, res] = await api.getVisitorCarMonthList({
        params: {
          month: moment(this.date).format('YYYY-MM'),
        },
      });
      if (!status) return;
      this.$store.commit('visitor/updateVisitorInMonth', res.data || []);
      this.$nextTick(() => {
        this.calculate(this.list);
      });

      this.loading = false;
    },
    dateFormat(value) {
      return [moment(+value).day(), moment(+value).date()];
    },

    calculate() {
      const width = document.body.clientWidth;
      this.$refs.topScroll.scrollLeft = (width / 750) * 80 * (this.select - 1);
    },
    hasAfter(index) {
      let now = this.listFilter[index];
      let next = this.listFilter[index + 1];
      if (index === this.listFilter.length - 1 && this.listFilter[index].status === 3) {
        return;
      }

      if (!next) return;
      if (now.endTime !== next.beginTime) {
        return 'space';
      }
    },
    setStore(val) {
      const roomInfo = localStorage.getItem('roomInfo');
      if (roomInfo) {
        localStorage.setItem('roomInfo', JSON.stringify(val));
      } else {
        localStorage.removeItem('roomInfo');
        localStorage.setItem('roomInfo', JSON.stringify(val));
      }
    },
    goToRoom(room, index) {
      const params = {
        authorId: this.authorId,
        index: index,
        date: moment(this.date).startOf('days').valueOf(),
        room: room,
      };
      this.setStore(params);
      // this.$store.commit('visitor/updateVisitorInMonthItem', room);
      this.$router.push({
        name: 'appointmentParkingSpace',
        query: params,
      });
    },
  },

  watch: {
    date() {
      this.initData();
      this.initCarList();
    },
    select() {
      this.date = this.list[this.select - 1];
    },
  },
  created() {
    // this.initState();
  },
  mounted() {
    this.initData();
    this.initCarList();
    if (this.list && this.list.length > 0) {
      this.calculate(this.list);
    }
  },
  beforeDestroy() {
    this.$store.commit('visitor/updateVisitorApplyInfo', this.applyInfo);
    //  if (!infoStore) {
    //   localStorage.setItem('infoStore', JSON.stringify(_this.applyInfo));
    // } else {
    //   localStorage.removeItem('infoStore');
    //   localStorage.setItem('infoStore', JSON.stringify(_this.applyInfo));
    // }
  },
};
</script>

<style lang="less" scoped>
.parking {
  padding-bottom: 100px;

  .header {
    padding: 0 30px;
    height: 104px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    font-weight: 600;
    .right {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 22px;
      color: #363d4d;
      letter-spacing: 0.4px;

      span {
        margin-right: 10px;

        &:nth-child(1)::before {
          content: '';
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #ff9999;
          margin-right: 5px;
          margin-bottom: 3px;
        }

        &:nth-child(2)::before {
          content: '';
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #fad487;
          margin-right: 5px;
          margin-bottom: 3px;
        }
      }
    }
  }

  .top {
    height: 120px;
    background-color: white;
    overflow-x: auto;
    overflow-y: hidden;
    position: relative;

    .con {
      display: flex;

      .date {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 0 8px;
        height: 120px;
        box-sizing: border-box;
        user-select: none;

        .area {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 72px;
          height: 90px;
          .week {
            font-size: 24px;
            color: #949aa4;
            line-height: 24px;
          }
          .day {
            font-size: 28px;
            color: #3d424d;
            letter-spacing: 1px;
            text-align: left;
            line-height: 42px;
            font-weight: 600;
          }
          // span {
          //   font-size: 24px;
          //   &:nth-child(1) {
          //     opacity: 0.8;
          //   }
          //   &:nth-child(2) {
          //     font-size: 28px;
          //     color: #3d424d;
          //     margin-top: 5px;
          //     font-weight: bold;
          //   }
          // }

          &.active {
            background: #00ccbf;
            border-radius: 8px;
            border-radius: 8px;
            span {
              color: white;
            }
          }
        }

        .foot {
          height: 30px;
          width: 72px;
          display: flex;
          justify-content: center;
          align-items: center;
          .invite {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: #ff9999;
            margin-right: 5px;
            margin-bottom: 3px;
          }

          .book {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: #fad487;
            margin-right: 5px;
            margin-bottom: 3px;
          }
        }
      }
    }
  }
  .titleSection {
    display: flex;
    align-items: center;
    padding: 38px 40px 20px;

    .carTitle {
      font-size: 30px;
      color: #3d424d;
      text-align: left;
      margin-right: 80px;
    }
    .right {
      text-align: left;
      font-size: 22px;
      color: #363d4d;

      span {
        &:nth-child(1) {
          color: #00ccbf;
          margin-right: 40px;
          &::before {
            content: '';
            display: inline-block;
            width: 20px;
            height: 20px;
            background-color: #00ccbf;
            margin-right: 10px;
          }
        }

        &:nth-child(2) {
          color: #fe8f7f;
          margin-right: 40px;
          &::before {
            content: '';
            display: inline-block;
            width: 20px;
            height: 20px;
            background-color: #fe8f7f;
            margin-right: 10px;
          }
        }
        &:nth-child(3) {
          opacity: 0.2;
          color: #000;
          &::before {
            content: '';
            display: inline-block;
            width: 20px;
            height: 20px;
            background-color: #000;
            opacity: 0.2;
            margin-right: 10px;
          }
        }
      }
    }
  }
  .list {
    background: #ffffff;
    border-radius: 10px;
    border-radius: 10px;
    margin-bottom: 16px;
    width: 690px;
    box-sizing: border-box;
    margin-left: 30px;
    padding: 0 20px;

    .listTop {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 0;
      img {
        &.arrowRight {
          width: 32px;
          height: 32px;
        }
      }
      .title {
        font-size: 32px;
        font-weight: bold;
        width: 400px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        text-align: left;
      }

      .option {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 28px;

        a {
          margin-right: 30px;
          color: #06ccbf;
          font-weight: bold;
          user-select: none;
        }

        .btn {
          font-size: 24px;
        }

        .van-button {
          height: 50px;
          line-height: 50px;
        }
      }
    }
    // .tips {
    //   text-align: left;
    //   color: #949aa4;
    //   font-size: 24px;
    // }
    .content {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      padding: 0px;
      //   margin-top: 40px;

      .section {
        position: relative;
        width: 672px;
        color: #949aa4;
        background: #f0f0f0;
        height: 8px;
        margin-bottom: 72px;

        .area {
          position: absolute;
          width: 14px;
          height: 8px;
          top: 0;
        }

        .dot {
          position: absolute;
          font-size: 22px;
          top: 30px;
          transform: translateX(-50%);

          &::before {
            content: '';
            position: absolute;
            left: 50% - 1px;
            top: -22px;
            width: 1px;
            height: 6px;
            background-color: #cccccc;
          }
        }
      }
    }
  }
}
</style>
